<template>
  <AssayDescriptionGrid :dv="dv" :fields="fields" />
  <VolumeEMDatasetAcquisitionDetails :dv="dv" />
</template>

<script>
import AssayDescriptionGrid from '../shared/AssayDescriptionGrid.vue'
import { CUSTOM_PROPERTIES } from '../../shared/fieldConstants.js'
import VolumeEMDatasetAcquisitionDetails from './VolumeEMDatasetAcquisitionDetails.vue'

const fields = [
  ['name'],
  ['id'],
  ['state', 'slot:fc:is_template'],
  ['imaging_method'],
  ['is_cryo_fib_sem'],
  ['correlative_assay'],
  ['widget:instrumentData'],
  ['slot:fc:run_dir'],
  ['description'],
  ['nr_of_samples'],
  CUSTOM_PROPERTIES,
  ['protocol_list'],
]

export default {
  name: 'AssayVolumeEM',
  components: {
    AssayDescriptionGrid,
    VolumeEMDatasetAcquisitionDetails,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup() {
    return { fields }
  },
}
</script>
